//region :: Imports ::
import React, {ReactElement, ReactNode} from 'react';
import MComponent from '../Toolkit/Components/Component';
import {MCancelIconName, MOkIconName} from '../Toolkit/Icons';
import {DialogPositionType} from 'primereact/dialog';
import Dialog from '../Toolkit/Components/Controls/Dialog';
import MButton from '../Toolkit/Components/Controls/Button';
import MFormControl from '../Toolkit/Components/Controls/FormControl';
import MTextBox from '../Toolkit/Components/Controls/TextBox';
import {Project} from '../Api/ControllerTypes/ProjectTypes';

//endregion

/** */
type Props = {
}

export type ProjectData = {
    code: string | undefined;
    name: string | undefined;
}

/** */
type State = {
    position?: DialogPositionType;
    visible: boolean;
    projectData: ProjectData;
    onAddWork?: (data: ProjectData) => void;
}

/** */
class AddProjectDialog extends MComponent<Props, State> {

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.initializeState();
    }

    /** */
    private bindMethods(): void {
        this.dialog_onHide = this.dialog_onHide.bind(this);

        this.getDialogTemplate = this.getDialogTemplate.bind(this);
        this.getFooterTemplate = this.getFooterTemplate.bind(this);
        this.ok_Click = this.ok_Click.bind(this);

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
    }

    /** */
    private initializeState(): void {
        this.state = {
            visible: false,
            projectData: {
                code: '',
                name: ''
            },
        };
    }

    /** */
    private dialog_onHide(): void {
        this.safeSetState((draft: State) => draft.visible = false);
    }

    /** */
    public show(inputCallback: (data: ProjectData) => void, position?: DialogPositionType) {
        this.safeSetState((draft: State) => {
            draft.position = position;
            draft.visible = true;
            draft.onAddWork = inputCallback;
            draft.projectData = {
                code: '',
                name: ''
            }
        });
    }

    public hide() {
        this.safeSetState((draft: State) => {
            draft.visible = false;
        });
    }

    private ok_Click() {
        this.state.onAddWork!(this.state.projectData!);
        this.hide();
    }

    private getDialogTemplate(): ReactNode {
        return (
            <div className="formgrid grid">
                <div className="col-12 md:col-12" style={{padding: "0px 0px 20px 0px"}}>
                    Select the work type to add to scheduled dates:

                </div>
                <div className="col-12 md:col-12">
                    <MFormControl label={'Project Code'}
                                  id={'projectCode'}>
                        {(fieldClasses: string | undefined) => {
                            return (
                                <MTextBox id='projectCode'
                                          disabled={false}
                                          maxLength={Project.CodeMaxLength}
                                          onChange={e =>
                                              this.safeSetState(draft => draft.projectData!.code = e.toString())
                                }/>
                            );
                        }}
                    </MFormControl>

                    <MFormControl label={'Project Name'}
                                  id={'projectName'}>
                        {(fieldClasses: string | undefined) => {
                            return (
                                <MTextBox id='projectName'
                                          disabled={false}
                                          maxLength={Project.NameMaxLength}
                                          onChange={e =>
                                              this.safeSetState(draft => draft.projectData!.name = e.toString())
                                          }/>
                            );
                        }}
                    </MFormControl>
                </div>
            </div>);
    }

    private getFooterTemplate(): ReactNode {
        return (
            <div>
                <MButton label="OK"
                         color="success"
                         icon={MOkIconName}
                         disabled={!this.isUploadAvailable()}
                         onClick={this.ok_Click}/>
                <MButton label={'Cancel'}
                         icon={MCancelIconName}
                         disabled={false}
                         onClick={this.hide}/>
            </div>
        );
    }

    private isUploadAvailable() {
        return (this.state.projectData.code?.length ?? 0) > 0 &&
            (this.state.projectData.name?.length ?? 0) > 0;
    }

    /** */
    public render(): ReactElement {

        return (
            <React.Fragment>
                <Dialog title={'Add project'}
                        content={this.getDialogTemplate()}
                        icon={{name: 'pi pi-pencil', color: 'mcolor-info'}}
                        footer={this.getFooterTemplate()}
                        position={this.state.position}
                        canClose={false}
                        closeOnEscape={false}
                        visible={this.state.visible}
                        onHide={this.dialog_onHide}
                />
            </React.Fragment>

        );

    }

}

export default AddProjectDialog;
